import { render, staticRenderFns } from "./VolunteerPrivateDialog.vue?vue&type=template&id=35f306eb"
import script from "./VolunteerPrivateDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerPrivateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports